import { Box, Snackbar, Tooltip, Typography } from "@material-ui/core";
import { LinkRounded } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import React, { KeyboardEventHandler, useState } from "react";
import withAppContext from "src/components/withAppContext";
import resolveUri from "src/resolveUri";
import {
  COPY_LINK,
  GET_COPY_SUCCESS,
  closedSnackbarOptions,
  errorSnackbarOptions,
  successSnackbarOptions,
} from "./constants";
import { useStyles } from "./styles";
import { ISurveyLinkProps } from "./types";
import { getLabel } from "./utils/getLabel";
import { ZENDESK_PARENT_SERVEY } from "src/constants";
import { useHistory } from 'react-router-dom';
import CancelModal from "src/components/CancelModal";
export const SurveyLink = withAppContext(
  ({ appContext, category, schoolData, code, clickDisable = false, isStarterPlan = false, route = "" }: ISurveyLinkProps) => {
    const history = useHistory();
    const { baseUri } = appContext;
    const [showParentAddon, setshowParentAddon] = useState(false)
    const classes = useStyles();
    const [{ message, open, severity }, setSnackbarOptions] = useState(
      closedSnackbarOptions
    );
    const label = getLabel(category);
    const encodedCategory = encodeURIComponent(category);
    const encodedCode = encodeURIComponent(code);
    const resolvedUri = resolveUri(
      `${baseUri}/${encodedCategory}/${encodedCode}`
    );

    const handleSnackbarClose = () => {
      setSnackbarOptions({
        message,
        open: false,
        severity,
      });
    };

    const handleCopyLink = async (link: string) => {
      try {
        await navigator.clipboard.writeText(link);
        setSnackbarOptions({
          ...successSnackbarOptions,
          message: GET_COPY_SUCCESS(category, schoolData?.isAdSurvey),
        });
      } catch (err) {
        setSnackbarOptions(errorSnackbarOptions);
        console.error(err);
      }
    };
    const handleCopyClick = () => {
      if (clickDisable) {
        setshowParentAddon(true)
        // window.open(ZENDESK_PARENT_SERVEY, "_blank");
      } else {
        handleCopyLink(resolvedUri)
      }

    };
    const handleCopyKeydown: KeyboardEventHandler<HTMLElement> = (e) => {
      handleSnackbarClose();
      if (e.key === "Enter") {
        handleCopyLink(resolvedUri);
      }
    };

    return (
      <div className="teamEvaluation">
        <Box className={classes.chip}>
          <Typography variant="h6" component="span" className={classes.label}>
            {console.log("labellabel", label,schoolData?.isAdSurvey)}
            {label === "Survey for Teacher" && schoolData?.isAdSurvey === true  ? "Survey for AD" : <>
            {label === "Students" && schoolData?.isAdSurvey === true   ? "Teachers" : label}
            </>
           }
          </Typography>
          <Box display="flex" gridGap="0.5rem" height="24px">
            <Box onClick={handleCopyClick} onKeyDown={handleCopyKeydown}>
              <Tooltip style={{cursor:"pointer"}} placement="bottom" title={COPY_LINK} tabIndex={0}>
                <LinkRounded color="primary" width="2px" />
              </Tooltip>
            </Box>
          </Box>
        </Box>
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          style={{
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
          }}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
        <CancelModal open={showParentAddon} handleOk={() => {
          if (isStarterPlan) {
            history.push(route)
          } else {
            window.open(ZENDESK_PARENT_SERVEY, "_blank");
          }
        }}
          handleClose={() => { setshowParentAddon(false) }}
          positiveText={"Upgrade Subscription "}
          title={"Parent Survey"}
          description={"If you would like to add parent surveys, please upgrade your subscription or add on parent surveys to your current subscription."}
        />
      </div>
    );
  }
);



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/survey-link/SurveyLink.tsx